export default __webpack_public_path__ + "static/media/clouds_getthrough.850e61dc.webp";